import React, { useState } from 'react';
import { Button } from './ui/button';
import { Menu, X, Phone, Mail } from 'lucide-react';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  
  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
  
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMenuOpen(false);
    }
  };

  return (
    <>
      {/* Top Bar */}
      <div className="bg-slate-800 text-white py-2 px-4 text-sm">
        <div className="container mx-auto flex justify-between items-center">
          <div className="flex items-center space-x-6">
            <div className="flex items-center space-x-2">
              <Mail className="w-4 h-4" />
              <span>airoto@hotmail.com</span>
              <span>|</span>
              <span>airoto@air-control.in</span>
            </div>
            <div className="flex items-center space-x-2">
              <Phone className="w-4 h-4" />
              <span>+91 90512 88221</span>
            </div>
          </div>
          <div className="text-xs">
            Monday – Friday: 10:00 AM – 6:00 PM
          </div>
        </div>
      </div>

      {/* Main Header */}
      <header className="bg-white shadow-lg sticky top-0 z-50">
        <div className="container mx-auto px-4">
          <div className="flex items-center justify-between h-20">
            {/* Logo */}
            <div className="flex items-center space-x-3">
              <img 
                src="img/logo-1.gif" 
                alt="Air Control Engineering Logo" 
                className="h-12 w-auto"
              />
              <div>
                <h1 className="text-xl font-bold bg-gradient-to-r from-[#0a8ec5] to-[#cd2d31] bg-clip-text text-transparent">Air Control Engineering</h1>
                <p className="text-sm text-gray-600">Pvt. Ltd.</p>
              </div>
            </div>

            {/* Desktop Navigation */}
            <nav className="hidden lg:flex items-center space-x-8">
              <button 
                onClick={() => scrollToSection('home')} 
                className="text-gray-700 hover:text-[#0a8ec5] font-medium transition-colors duration-200"
              >
                Home
              </button>
              <button 
                onClick={() => scrollToSection('about')} 
                className="text-gray-700 hover:text-[#0a8ec5] font-medium transition-colors duration-200"
              >
                About Us
              </button>
              <button 
                onClick={() => scrollToSection('products')} 
                className="text-gray-700 hover:text-[#0a8ec5] font-medium transition-colors duration-200"
              >
                Products & Services
              </button>
              <button 
                onClick={() => scrollToSection('projects')} 
                className="text-gray-700 hover:text-[#0a8ec5] font-medium transition-colors duration-200"
              >
                Projects
              </button>
              <button 
                onClick={() => scrollToSection('clientele')} 
                className="text-gray-700 hover:text-[#0a8ec5] font-medium transition-colors duration-200"
              >
                Clientele
              </button>
              <button 
                onClick={() => scrollToSection('contact')} 
                className="text-gray-700 hover:text-[#0a8ec5] font-medium transition-colors duration-200"
              >
                Contact
              </button>
            </nav>

            {/* CTA Button */}
            {/* <div className="hidden lg:block">
              <Button 
                onClick={() => scrollToSection('contact')}
                className="bg-[#cd2d31] hover:bg-[#b02529] text-white px-6 py-2 rounded-lg font-medium transition-all duration-200 hover:shadow-lg"
              >
                Get Free Quote
              </Button>
            </div> */}

            {/* Mobile Menu Button */}
            <button 
              onClick={toggleMenu}
              className="lg:hidden p-2 text-gray-700 hover:text-[#0a8ec5] transition-colors"
            >
              {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>

          {/* Mobile Navigation */}
          {isMenuOpen && (
            <div className="lg:hidden bg-white border-t border-gray-200 py-4">
              <nav className="flex flex-col space-y-3">
                <button 
                  onClick={() => scrollToSection('home')} 
                  className="text-left text-gray-700 hover:text-[#0a8ec5] font-medium py-2 transition-colors"
                >
                  Home
                </button>
                <button 
                  onClick={() => scrollToSection('about')} 
                  className="text-left text-gray-700 hover:text-[#0a8ec5] font-medium py-2 transition-colors"
                >
                  About Us
                </button>
                <button 
                  onClick={() => scrollToSection('products')} 
                  className="text-left text-gray-700 hover:text-[#0a8ec5] font-medium py-2 transition-colors"
                >
                  Products & Services
                </button>
                <button 
                  onClick={() => scrollToSection('projects')} 
                  className="text-left text-gray-700 hover:text-[#0a8ec5] font-medium py-2 transition-colors"
                >
                  Projects
                </button>
                <button 
                  onClick={() => scrollToSection('clientele')} 
                  className="text-left text-gray-700 hover:text-[#0a8ec5] font-medium py-2 transition-colors"
                >
                  Clientele
                </button>
                <button 
                  onClick={() => scrollToSection('contact')} 
                  className="text-left text-gray-700 hover:text-[#0a8ec5] font-medium py-2 transition-colors"
                >
                  Contact
                </button>
                {/* <Button 
                  onClick={() => scrollToSection('contact')}
                  className="bg-[#cd2d31] hover:bg-[#b02529] text-white px-6 py-2 rounded-lg font-medium mt-2 w-full transition-all duration-200"
                >
                  Get Free Quote
                </Button> */}
              </nav>
            </div>
          )}
        </div>
      </header>
    </>
  );
};

export default Header;